<template>
  <div>
    <search-list :projectList="BuildInfo" @findData="findData"></search-list>
    <div class="page-wrapper">
      <table-list

        :columns="columns"
        :data="data"
        :total="total"
        :current="current"
        :loading="loading"
        @change-page="changePage"
      >
        <Button type="primary" class="btn" @click="changeKey" v-p="{api:'functionalarea/add'}">添加功能区</Button>
      </table-list>
    </div>
    <add-fn-area-modal @refresh="updateTable" :n="key" :projectList="BuildInfo"></add-fn-area-modal>
    <update-fn-area-modal :n="modifyKey" :projectList="BuildInfo" :ribbonId="fid" :initFormData="functionalAreaData"
                          @refresh="updateTable"></update-fn-area-modal>
    <delete-fn-area-modal :n="deleteKey" :fid="fid" :name="name" @refresh="updateTable"></delete-fn-area-modal>
  </div>

</template>

<script type="text/ecmascript-6">
  import {getList, addFunctionalarea, getBuildInfo} from "api/functionalArea";
  import SearchList from './components/SearchList';
  import AddFnAreaModal from './components/AddFnAreaModal';
  import UpdateFnAreaModal from './components/UpdateFnAreaModal';
  import DeleteFnAreaModal from './components/DeleteFnAreaModal';
  import TableList from 'components/TableList/index';

  export default {
    name: 'functionalarea',
    components: {
      SearchList,
      TableList,
      AddFnAreaModal,
      UpdateFnAreaModal,
      DeleteFnAreaModal
    },
    data() {
      return {
        key: 0,
        deleteKey: 0,
        modifyKey: 0,
        fid: null,
        name: '',
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: '功能区名称',
            align: 'center',
            key: 'name'
          },
          {
            title: '面积（㎡）',
            align: 'center',
            key: 'area'
          },
          {
            title: '项目',
            align: 'center',
            key: 'projectName'
          },

          {
            title: '楼栋',
            align: 'center',
            key: 'buildingName'
          },
          {
            title: '楼层',
            align: 'center',
            key: 'floor'
          },
          {
            title: '创建人',
            align: 'center',
            key: 'createName'
          },
          {
            title: '创建时间',
            align: 'center',
            key: 'createTime'
          },
          {
            title: '操作',
            key: 'action',
            width: 250,
            align: 'center',
            render: (h, params) => {
              return h('div',

                [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    directives: [
                      {
                        name: 'p',
                        value: {
                          api: 'archives/list'
                        }
                      }
                    ],
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        /*
                        this.counts++;
                        this.roomId = params.row.roomId;
                        this.deviceType = params.row.deviceType;
                        this.projectFid = params.row.projectId
                      */
                        let projectId = params.row.projectId;
                        let fid = params.row.fid;
                        this.$router.push({name: 'property', params: {projectId: projectId, fid: fid,targetTab:'2'}})
                      }
                    }
                  }, '查看物品'),

                  h('Button', {

                    props: {
                      type: 'success',
                      size: 'small',
                    },
                    directives: [
                      {
                        name: 'p',
                        value: {
                          api: 'functionalarea/update'
                        }
                      }
                    ],
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.modifyKey++;
                        this.functionalAreaData.fid = params.row.fid;
                        this.functionalAreaData.name = params.row.name;
                        this.functionalAreaData.area = params.row.area;
                        this.functionalAreaData.projectId = params.row.projectId;
                        this.functionalAreaData.buildingId = params.row.buildingId;
                        this.functionalAreaData.floor = params.row.floor
                        // console.log(this.functionalAreaData)
                      }
                    }
                  }, '修改'),
                  h('Button', {
                    props: {
                      type: 'ghost',
                      size: 'small',
                    },
                    directives: [
                      {
                        name: 'p',
                        value: {
                          api: 'functionalarea/delete'
                        }
                      }
                    ],
                    on: {
                      click: () => {
                        this.deleteKey++;
                        this.fid = params.row.fid;
                        this.name = params.row.name;
                      }
                    }
                  }, '删除')])
            }
          },
        ],
        params: {
          page: 1,
          limit: 10,
          projectId: "",
          buildingId: "",
          floor: ""
        },
        searchData: null,
        data: [],
        BuildInfo: [],
        total: 0,
        current: 1,
        loading: false,
        functionalAreaData: {
          fid: '',
          name: '',
          area: '',
          projectId: '',
          buildingId: '',
          floor: ''
        }
      }
    },
    created() {
      this.initFunctionalAreaList(this.params);
      getBuildInfo().then(res => {
        this.BuildInfo = res.data
      })
    },
    methods: {
      changeKey() {
        this.key++
      },
      setSearchData(data) {
        this.searchData = Object.assign({}, data)
      },
      initFunctionalAreaList(params) {
        getList(params).then(res => {
          this.data = res.data.rows;
          this.total = res.data.total;
        })
      },
      updateTable() {
        if (this.searchData === null) {
          this.initFunctionalAreaList(this.params)
        } else {
          this.searchData.page = 1;
          this.initFunctionalAreaList(this.searchData)
        }
      },
      findData(params) {
        this.setSearchData(params);
        this.current = 1;
        this.initFunctionalAreaList(params)
      },
      changePage(n) {
        this.current = n;
        this.params.page = n;
        if (this.searchData === null) {
          this.initFunctionalAreaList(this.params)
        } else {
          this.searchData.page = n;
          this.initFunctionalAreaList(this.searchData)
        }
      }
    }

  }
</script>

<style lang="css" scoped>
  .btn {
    margin-bottom: 20px;
  }
</style>
